export default __webpack_public_path__ + "static/media/SunTrust.4fd040e5.svg";